import { render, staticRenderFns } from "./TextSettingsDesktop.vue?vue&type=template&id=93df8f54&scoped=true&"
import script from "./TextSettingsDesktop.vue?vue&type=script&lang=ts&"
export * from "./TextSettingsDesktop.vue?vue&type=script&lang=ts&"
import style0 from "./TextSettingsDesktop.vue?vue&type=style&index=0&id=93df8f54&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93df8f54",
  null
  
)

export default component.exports